export const GET_GAME_WEEKS = "GET_GAME_WEEKS";
export const DELETE_GAME_WEEK = "DELETE_GAME_WEEK";
export const ADD_GAME_WEEK = "ADD_GAME_WEEK";
export const EDIT_GAME_WEEK = "EDIT_GAME_WEEK";
export const CLEAR_GAME_WEEKS = "CLEAR_GAME_WEEKS";